import StudentTasks from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'lessonNumber':
      return [key, Number.parseInt(val, 10)];
    case 'sessionId':
    case 'unitId':
      return [key, `${val}`];
    default:
      return [key, val];
  }
};

const create = (data) => new StudentTasks(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/StudentTasks/create.js